// from general.js
/* global dcAnalytics isMobileView dcAnalytics scrollToPageTop Handlebars toggleSignInOverlay Uri submitFormToIframe */

import './profileDescForm.tmpl.js';
import { requireLoginForPageUpdate } from '../../utils/userUtils.js';
import { setup, hide } from '../../common/readMoreLink.js';


const TEACHER_PROMPT = 'Give supporters a glimpse inside your classroom to inspire donations.';
const LINK_TEXT_FOR_BLANK_DESCRIPTION = 'Describe your students';
const LINK_TEXT_FOR_NON_BLANK_DESCRIPTION = 'Edit classroom description';

function editProfileDescForTeacherProfile() {
    if ($('#profile-desc-form').length === 0) {
        const context = [];
        context.callback = 'profileDescCallbackForTeacherProfile';
        const templateV = Handlebars.templates['profileDescForm.tmpl'];
        const htmlV = templateV(context);
        $('#profile-desc').after(htmlV);
        $('.js-submit-desc').on('click', submitProfileDesc);
        $('.js-hide-desc').on('click', hideEditProfileDesc);
    }
    if ($('#profile-desc-text').length > 0) {
        $('#profileDesc').val($('#profile-desc-text').html());
    }
    $('#profile-desc').hide();
    $('#profile-desc-form').show();
    if (!isMobileView()) {
        // we need to account for the floating give bar
        scrollToPageTop($('#profile-desc-form').offset().top - 100);
    }
    $('#profileDesc').on('keyup change input', function () {
        checkMaxLength(this);
    });
    checkMaxLength($('#profileDesc')[0]);
    dcAnalytics.trackEventGA([pageName, 'Welcome message', 'Edit welcome message']);
}

// JSONP callback
window.profileDescCallbackForTeacherProfile = function (response) {
    if (response && response.data.success) {
        setupEditClassroomDescriptionSection(response.data.profileDesc);
        hideEditProfileDesc();
        // append timestamp to url so that if teacher refreshes page it will bust through cache and show updated classroom description
        const urlWithCacheBuster = (new Uri(window.location)).replaceQueryParam('timestamp', (new Date()).getTime()).toString();
        history.replaceState(null, '', urlWithCacheBuster);
    } else if (response.data.signinRequired) {
        $('#profileDescError').html('Please first sign in to make this change.');
    }
};

function submitProfileDesc() {
    $(window).off('userCookiesReset.submitProfileDesc');
    if (requireLoginForPageUpdate()) {
        toggleSignInOverlay(null, true);
        $(window).on('userCookiesReset.submitProfileDesc', function () { submitProfileDesc(); });
        return;
    }
    $('#profileDescError').html('');
    submitFormToIframe($('#profile-desc-form')[0], 'teacherProfileDescIframe');
    dcAnalytics.trackEventGA([pageName, 'Welcome message', 'Save welcome message']);
}

function hideEditProfileDesc() {
    $('#profile-desc').show();
    $('#profile-desc-form').hide();
    $('#profileDesc').val('');
    dcAnalytics.trackEventGA([pageName, 'Welcome message', 'Cancel']);
}

function checkMaxLength(el) {
    const maxLength = 930;
    if ($(el).val().length > maxLength) {
        $('#characters-feedback').hide();
        $('#desc-too-long').show();
        $('.js-submit-desc').addClass('disabled');
    } else {
        $('#characters-feedback').show();
        $('#desc-too-long').hide();
        $('.js-submit-desc').removeClass('disabled');
        $('#charactersRemaining').html(maxLength - $(el).val().length);
    }
}

export function setupEditClassroomDescriptionSection(classroomDescription) {
    $('.js-edit-classroom-description-element').remove();
    if (classroomDescription) {
        $('.js-edit-classroom-description').removeClass('no-description');
        $('.js-edit-classroom-description .js-placeholder').after(getNonBlankEditClassroomDescriptionSnippet(classroomDescription));
        setTimeout(addClassroomDescriptionReadMoreLinkOnlyIfTooLong, 1000);
    } else {
        $('.js-edit-classroom-description').addClass('no-description');
        $('.js-edit-classroom-description .js-placeholder').after(getBlankEditClassroomDescriptionSnippet());
    }
    $('.js-edit-classroom-description-link').click(function () {
        editProfileDescForTeacherProfile();
        return false;
    });
}

function getBlankEditClassroomDescriptionSnippet() {
    let elem = '<p class="prompt js-edit-classroom-description-element">';
    elem += TEACHER_PROMPT;
    elem += '</p>';
    elem += '<a id="profile-desc-link" class="editable-link js-edit-classroom-description-element js-edit-classroom-description-link">';
    elem += LINK_TEXT_FOR_BLANK_DESCRIPTION;
    elem += '</a>';
    return elem;
}

function getNonBlankEditClassroomDescriptionSnippet(classroomDescription) {
    let elem = '<a id="profile-desc-link" class="editable-link js-edit-classroom-description-element js-edit-classroom-description-link">';
    elem += LINK_TEXT_FOR_NON_BLANK_DESCRIPTION;
    elem += '</a>';
    elem += '<p id="profile-desc-text" class="js-edit-classroom-description-element js-profile-desc-text">';
    elem += classroomDescription;
    elem += '</p>';
    return elem;
}

let defaultDescContainerHeight;

$(function () {
    defaultDescContainerHeight = $('.js-classroom-description').css('max-height');
});

export function addClassroomDescriptionReadMoreLinkOnlyIfTooLong() {
    const descCutoffDesktop = 300;
    const descCutoffMobile = 180;

    const windowWidth = $(window).width();
    let descContentsHeight = 0;
    let mobileDescContentsHeight = 0;

    $('.js-classroom-description').css('max-height', defaultDescContainerHeight);

    $('.js-profile-desc-text').each(function () {
        descContentsHeight += $(this).outerHeight();
    });

    $('.js-classroom-description h3').each(function () {
        mobileDescContentsHeight += $(this).outerHeight(true);
    });
    mobileDescContentsHeight += descContentsHeight;

    if (windowWidth > breakpointMobileWidthPx) {
        if (descContentsHeight > descCutoffDesktop) {
            setup('.js-profile-desc-read-more', '.js-classroom-description');
        } else {
            hide('.js-profile-desc-read-more', '.js-classroom-description');
        }
    } else {
        if (mobileDescContentsHeight > descCutoffMobile) {
            setup('.js-profile-desc-read-more', '.js-classroom-description');
        } else {
            hide('.js-profile-desc-read-more', '.js-classroom-description');
        }
    }
}
